/** Number formatting from the reference tool. AUD currency, en-AU locale. */

const AUD = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  maximumFractionDigits: 0,
});

/** Whole dollars, e.g. "$301,675". Non-finite values show as "$0". */
export function money(n: number): string {
  return isFinite(n) ? AUD.format(Math.round(n)) : "$0";
}

/** Plain number with up to `d` decimal places (default 0). */
export function num(n: number, d?: number): string {
  return (isFinite(n) ? n : 0).toLocaleString("en-AU", { maximumFractionDigits: d || 0 });
}
